module.exports = __webpack_public_path__ + "static/media/loader.433c1b0d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/loader.gif
// module id = 30
// module chunks = 0